import { useState, useContext } from "react";
import { TextField, Button, Typography, Container, Box, Link, IconButton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { login } from '../../services/auth'
import userContext from '../../context/userContext';

const Login = () => {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserStore } = useContext(userContext);

  const handleLogin = async(e) => {
    console.log(phone, password)
    e.preventDefault();
    
    if (phone && password) {
        const user = await login(phone, password)
        setUserStore(user.payload)
        if (location?.state?.redirectTo) {
          navigate(location.state.redirectTo)
        } else {
          navigate('/')
        }
    }
    // Add login logic here
  };

  return (
    <Container maxWidth="xs">
        <Box sx={{ mt: 2 }}>
            <IconButton onClick={()=>{navigate(-1)}}><ArrowBackIcon/></IconButton>
        </Box>
      <Box sx={{ mt: 8, p: 3, boxShadow: 3, borderRadius: 2, textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          Login
        </Typography>        
          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button onClick={handleLogin} variant="contained" fullWidth sx={{ mt: 2 }}>
            Login
          </Button>        
        <Typography variant="body2" sx={{ mt: 2 }}>
          Don't have an account?{" "}
          <Link onClick={() => navigate("/register")} sx={{ cursor: "pointer" }}>
            Register
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default Login;
